export default __webpack_public_path__ + "static/media/TUSD.ab10aecb.svg";